/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Credit_Packs_No_ExpiryInputs */

const en_agb_credit_packs_no_expiry = /** @type {(inputs: Agb_Credit_Packs_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchased credits do not expire.`)
};

const de_agb_credit_packs_no_expiry = /** @type {(inputs: Agb_Credit_Packs_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erworbene Credits verfallen nicht (kein Ablaufdatum).`)
};

const fr_agb_credit_packs_no_expiry = /** @type {(inputs: Agb_Credit_Packs_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les credits achetes n'expirent pas.`)
};

const es_agb_credit_packs_no_expiry = /** @type {(inputs: Agb_Credit_Packs_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los creditos comprados no caducan.`)
};

const it_agb_credit_packs_no_expiry = /** @type {(inputs: Agb_Credit_Packs_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I crediti acquistati non scadono.`)
};

const nl_agb_credit_packs_no_expiry = /** @type {(inputs: Agb_Credit_Packs_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekochte credits verlopen niet.`)
};

const pl_agb_credit_packs_no_expiry = /** @type {(inputs: Agb_Credit_Packs_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakupione kredyty nie wygasaja.`)
};

const fi_agb_credit_packs_no_expiry = /** @type {(inputs: Agb_Credit_Packs_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostetut krediitit eivät vanhene.`)
};

const da_agb_credit_packs_no_expiry = /** @type {(inputs: Agb_Credit_Packs_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kobte credits udlober ikke.`)
};

const sv_agb_credit_packs_no_expiry = /** @type {(inputs: Agb_Credit_Packs_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopta krediter gar inte ut.`)
};

/**
* | output |
* | --- |
* | "Purchased credits do not expire." |
*
* @param {Agb_Credit_Packs_No_ExpiryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_credit_packs_no_expiry = /** @type {((inputs?: Agb_Credit_Packs_No_ExpiryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Credit_Packs_No_ExpiryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_credit_packs_no_expiry(inputs)
	if (locale === "fr") return fr_agb_credit_packs_no_expiry(inputs)
	if (locale === "es") return es_agb_credit_packs_no_expiry(inputs)
	if (locale === "it") return it_agb_credit_packs_no_expiry(inputs)
	if (locale === "nl") return nl_agb_credit_packs_no_expiry(inputs)
	if (locale === "pl") return pl_agb_credit_packs_no_expiry(inputs)
	if (locale === "fi") return fi_agb_credit_packs_no_expiry(inputs)
	if (locale === "da") return da_agb_credit_packs_no_expiry(inputs)
	if (locale === "sv") return sv_agb_credit_packs_no_expiry(inputs)
	return en_agb_credit_packs_no_expiry(inputs)
});